export class MenuUtils {

    public static LEFT_Y_CURR = 0;
    public static RIGHT_Y_CURR = 0;
}

export enum MenuColumn { LEFT, RIGHT, OTHER }